module.exports = __webpack_public_path__ + "static/media/Noto2.8877e71a.webp";